import { getFeatureFlag } from "services/Flags";

import { adPixels } from "./adPixels";

type AdTracking = Parameters<typeof adPixels.configure>[0];

/**
 * The only way the app starts ad tracking. A flag that is off, still resolving, or failed to
 * resolve leaves tracking off, so nothing asks for iOS tracking permission or loads a vendor script.
 */
export async function configureAdPixels(adTracking: AdTracking): Promise<void> {
  const enabled = await getFeatureFlag("adPixels").catch(() => false);
  if (enabled === true) adPixels.configure(adTracking);
}
